export const SITE_THEMES = [
  {
    id: "v6",
    name: "Les Boules classique",
    description: "Accueil éditorial avec une une, des sujets secondaires et les derniers articles."
  },
  {
    id: "grid",
    name: "Les Boules — Grille continue",
    description: "Grille responsive avec chargement progressif des articles sur ordinateur, tablette et mobile."
  },
  {
    id: "mobile",
    name: "Les Boules — Une mobile",
    description: "Une visuelle, rubriques défilantes et grille compacte inspirée d’un journal mobile."
  }
] as const;

export type SiteThemeId = typeof SITE_THEMES[number]["id"];

export function isSiteThemeId(value: string): value is SiteThemeId {
  return SITE_THEMES.some((theme) => theme.id === value);
}
